import { Trans } from '@lingui/macro'
import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { intercomService } from '../services/intercom'

interface RouteBasedIntercomProps {
    appId: string
    user?: any
    enabledRoutes: string[]
}

export const RouteBasedIntercom: React.FC<RouteBasedIntercomProps> = ({ appId, user, enabledRoutes }) => {
    const location = useLocation()

    const isRouteEnabled = enabledRoutes.some((route) => location.pathname.startsWith(route))

    useEffect(() => {
        if (!isRouteEnabled || !user) {
            // Shutdown Intercom when leaving enabled routes
            if (!isRouteEnabled) {
                intercomService.shutdown()
            }
            return
        }

        // Dynamically find the email key in user object
        const emailKey = Object.keys(user).find((key) => key.endsWith('email'))
        const userEmail = emailKey ? user[emailKey] : null

        if (userEmail && appId) {
            const initializeIntercom = () => {
                try {
                    intercomService.initialize({
                        app_id: appId,
                        user_id: user.sub,
                        email: userEmail,
                        name: user.name,
                        company:
                            user.org_id && user.org_name
                                ? {
                                      id: user.org_id,
                                      name: user.org_name
                                  }
                                : undefined
                    })
                } catch (error) {
                    console.error(<Trans>Failed to initialize Intercom</Trans>, error)
                }
            }

            // Add a delay to ensure the script is loaded
            setTimeout(initializeIntercom, 2000)
        }
    }, [isRouteEnabled, user, appId, location.pathname, enabledRoutes])

    return null // This component doesn't render anything visible
}
